import React, { useEffect, useState } from "react";
import { transformDescription } from "./shared";
import { SectionData, ComponentRenderProps } from "./index";
import { useDeviceType } from "@/hooks/useDeviceType";

interface CustTextProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const CustText = ({ sectionData, props }: CustTextProps): JSX.Element | null => {
    const componentTag = sectionData.uiCompType?.options?.component || sectionData.uiCompType?.options?.variant || 'p';
    //TODO: Add support for mobile
    const deviceType = useDeviceType();
    const styles = sectionData.uiCompType?.styles || {};
    // const [styles, setStyles] = useState(sectionData.uiCompType?.styles || {});
    // useEffect(() => {
    //     if (deviceType === "Mobile" && sectionData.uiCompType?.mStyles) {
    //         setStyles({ ...sectionData.uiCompType?.styles, ...sectionData.uiCompType?.mStyles });
    //     }
    // }, [deviceType, sectionData.uiCompType]);
    return (
        <>
            {sectionData.text &&
                transformDescription(sectionData.text || '',
                    sectionData.uiCompType?.className,
                    (sectionData.trackId),
                    styles,
                    componentTag,
                    props, deviceType)
            }
        </>
    );
}
export default CustText;
